/*
 * Carga el CSS y el JS de una seccion solo cuando esa seccion esta por entrar en
 * pantalla, para que el header y el hero no compitan con lo que esta mas abajo.
 * Se usa desde el snippet `lazy-assets-chroxel`.
 */
class LazyAssetsChroxel extends HTMLElement {
  static loaded = new Set();

  static pathOf(url) {
    try {
      return new URL(url, document.baseURI).pathname;
    } catch (error) {
      return url;
    }
  }

  static alreadyInDocument(url) {
    const path = LazyAssetsChroxel.pathOf(url);
    if (LazyAssetsChroxel.loaded.has(path)) return true;
    const selector = `link[rel="stylesheet"], script[src]`;
    return Array.from(document.querySelectorAll(selector)).some(
      (node) => LazyAssetsChroxel.pathOf(node.href || node.src) === path
    );
  }

  connectedCallback() {
    if (this.hasLoaded) return;

    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      this.loadAssets();
      return;
    }

    const target = this.closest('.shopify-section') || this.parentElement || this;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadAssets();
      },
      { rootMargin: '1500px 0px' }
    );
    this.observer.observe(target);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  urlsFrom(attribute) {
    return (this.dataset[attribute] || '')
      .split(',')
      .map((url) => url.trim())
      .filter(Boolean);
  }

  loadAssets() {
    if (this.hasLoaded) return;
    this.hasLoaded = true;
    if (this.observer) this.observer.disconnect();

    this.urlsFrom('styles').forEach((href) => {
      if (LazyAssetsChroxel.alreadyInDocument(href)) return;
      LazyAssetsChroxel.loaded.add(LazyAssetsChroxel.pathOf(href));
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    });

    this.urlsFrom('scripts').forEach((src) => {
      if (LazyAssetsChroxel.alreadyInDocument(src)) return;
      LazyAssetsChroxel.loaded.add(LazyAssetsChroxel.pathOf(src));
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      document.head.appendChild(script);
    });
  }
}

customElements.define('lazy-assets-chroxel', LazyAssetsChroxel);
